export async function get() {
  if (navigator.geolocation) {
    return new Promise((resolve) => {
      navigator.geolocation.getCurrentPosition((location) => {
        if (location && location.coords) {
          resolve({
            lat: location.coords.latitude,
            lng: location.coords.longitude,
          });
        }
      });
    });
  }

  return null;
}

export function watch(cb) {
  if (navigator.geolocation) {
    return navigator.geolocation.watchPosition((location) => {
      if (location && location.coords) {
        cb({
          lat: location.coords.latitude,
          lng: location.coords.longitude,
        });
      }
    });
  }

  return null;
}

export async function stopWatching(id) {
  if (navigator.geolocation) {
    navigator.geolocation.clearWatch(id);
  }
}
